import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification"
export default class extends Controller {
  static targets = ['new', 'content', 'notification']

  connect() {
    this.element.dataset.action += ` notification@window->notification#show`
  }

  clearTimeouts() {
    clearTimeout(this.hideTimeout);
    clearTimeout(this.removeTimeout);
  }

  show(e) {
    this.clearTimeouts()

    if (e) {
      this.message(e.detail.type, e.detail.description);
    }

    this.notificationTarget.classList.add('notification--show', 'notification--active')

    this.hideTimeout = setTimeout(() => {
      this.hide()
    }, 5000);
  }

  hide() {
    this.notificationTarget.classList.remove('notification--show')
    this.notificationTarget.classList.add('notification--hide')

    this.removeTimeout = setTimeout(() => {
      this.notificationTarget.classList.remove('notification--active')
      this.notificationTarget.classList.remove('notification--hide')
    }, 1000);
  }

  newTargetConnected() {
    this.message(this.newTarget.dataset.kind, this.newTarget.innerHTML);

    this.newTarget.remove()

    this.show();
  }

  message(type, message) {
    let icon = 'face-smile-beam'

    switch (type) {
      case 'error':
      case 'alert':
      case 'danger':
        icon = 'face-sad-tear'
        break;
    }

    this.notificationTarget.classList.add(`notification--${type}`)

    this.contentTarget.innerHTML = `<div class="elements elements--x"><span class="icon text-lg"><i class="fa-${icon} fa-duotone"></i></span><span>${message}</span></div>`
  }
}
